var _defs, _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgWelcome(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 2113.14 945.8",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, "\n            .cls-1{fill:#fff;}.cls-2{fill:url(#Gradiente_sem_nome_8);}.cls-3{fill:url(#Gradiente_sem_nome_7);}.cls-4{fill:url(#Gradiente_sem_nome_7-2);}.cls-5{fill:url(#Gradiente_sem_nome_7-3);}.cls-6{fill:url(#Gradiente_sem_nome_7-4);}.cls-7{fill:url(#Gradiente_sem_nome_7-5);}.cls-8{fill:url(#Gradiente_sem_nome_7-6);}.cls-9{fill:url(#Gradiente_sem_nome_7-7);}.cls-10{fill:url(#Gradiente_sem_nome_7-8);}.cls-11{fill:url(#Gradiente_sem_nome_7-9);}.cls-12{fill:url(#Gradiente_sem_nome_7-10);}.cls-13{fill:url(#Gradiente_sem_nome_7-11);}.cls-14{fill:url(#Gradiente_sem_nome_7-12);}.cls-15{fill:url(#Gradiente_sem_nome_7-13);}.cls-16{fill:url(#Gradiente_sem_nome_7-14);}.cls-17{fill:url(#Gradiente_sem_nome_7-15);}.cls-18{fill:url(#Gradiente_sem_nome_7-16);}.cls-19{fill:url(#Gradiente_sem_nome_7-17);}.cls-20{fill:url(#Gradiente_sem_nome_7-18);}.cls-21{fill:url(#Gradiente_sem_nome_7-19);}.cls-22{fill:url(#Gradiente_sem_nome_7-20);}.cls-23{fill:url(#Gradiente_sem_nome_7-21);}.cls-24{fill:url(#Gradiente_sem_nome_7-22);}.cls-25{fill:url(#Gradiente_sem_nome_7-23);}.cls-26{fill:url(#Gradiente_sem_nome_7-24);}.cls-27{fill:url(#Gradiente_sem_nome_7-25);}.cls-28{fill:url(#Gradiente_sem_nome_7-26);}.cls-29{fill:url(#Gradiente_sem_nome_7-27);}.cls-30{fill:url(#Gradiente_sem_nome_7-28);}.cls-31{fill:url(#Gradiente_sem_nome_7-29);}.cls-32{fill:url(#Gradiente_sem_nome_7-30);}.cls-33{fill:url(#Gradiente_sem_nome_7-31);}.cls-34{fill:url(#Gradiente_sem_nome_7-32);}.cls-35{fill:url(#Gradiente_sem_nome_7-33);}.cls-36{fill:url(#Gradiente_sem_nome_7-34);}.cls-37{fill:#1d4018;}.cls-38{fill:url(#Gradiente_sem_nome_6);}.cls-39{fill:#2c764f;}.cls-40{fill:url(#Gradiente_sem_nome_5);}.cls-41{fill:url(#Gradiente_sem_nome_5-2);}.cls-42{fill:url(#Gradiente_sem_nome_4);}.cls-43{fill:url(#Gradiente_sem_nome_4-2);}.cls-44{fill:#ea9804;}.cls-45{fill:url(#Gradiente_sem_nome_4-3);}.cls-46{fill:url(#Gradiente_sem_nome_2);}.cls-47{fill:url(#Gradiente_sem_nome_4-4);}.cls-48{fill:url(#Gradiente_sem_nome_2-2);}.cls-49{fill:url(#Gradiente_sem_nome_2-3);}.cls-50{fill:#b4583d;}.cls-51{fill:url(#Gradiente_sem_nome_2-4);}.cls-52{fill:url(#Gradiente_sem_nome_2-5);}.cls-53{fill:url(#Gradiente_sem_nome_3);}.cls-54{fill:url(#Gradiente_sem_nome_2-6);}.cls-55{fill:url(#Gradiente_sem_nome_2-7);}.cls-56{fill:url(#Gradiente_sem_nome_2-8);}.cls-57{fill:url(#Gradiente_sem_nome_2-9);}.cls-58{fill:url(#Gradiente_sem_nome_2-10);}.cls-59{fill:#2b993a;}.cls-60,.cls-61{fill:none;stroke:#1d4018;}.cls-60{stroke-miterlimit:10;stroke-width:0.5px;stroke-dasharray:3\n            3;}.cls-61{stroke-linecap:round;stroke-linejoin:round;stroke-width:2px;}\n        "), /*#__PURE__*/React.createElement("linearGradient", {
    id: "Gradiente_sem_nome_8",
    x1: 1058.9,
    y1: 889.61,
    x2: 1058.9,
    y2: 56.16,
    gradientTransform: "matrix(1.03, 0.04, -0.04, 1, -14.34, -67.96)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#f6ead4",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.11,
    stopColor: "#f6ead4",
    stopOpacity: 0.02
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.23,
    stopColor: "#f6ead4",
    stopOpacity: 0.08
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.37,
    stopColor: "#f6ead4",
    stopOpacity: 0.17
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.51,
    stopColor: "#f6ead4",
    stopOpacity: 0.31
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.66,
    stopColor: "#f6ead4",
    stopOpacity: 0.48
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.81,
    stopColor: "#f6ead4",
    stopOpacity: 0.69
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.96,
    stopColor: "#f6ead4",
    stopOpacity: 0.94
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#f6ead4"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "Gradiente_sem_nome_7",
    x1: 1514.08,
    y1: 826.29,
    x2: 1514.08,
    y2: 445.66,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#2b993a",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.11,
    stopColor: "#2d9b3b",
    stopOpacity: 0.02
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.24,
    stopColor: "#339f3c",
    stopOpacity: 0.08
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.38,
    stopColor: "#3ca73e",
    stopOpacity: 0.19
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.53,
    stopColor: "#4ab242",
    stopOpacity: 0.33
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.69,
    stopColor: "#5bc046",
    stopOpacity: 0.52
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.84,
    stopColor: "#70d14c",
    stopOpacity: 0.74
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#88e552"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "Gradiente_sem_nome_7-2",
    x1: 1368.07,
    y1: 826.29,
    x2: 1368.07,
    y2: 445.66,
    xlinkHref: "#Gradiente_sem_nome_7"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "Gradiente_sem_nome_7-3",
    x1: 1480.25,
    y1: 826.29,
    x2: 1480.25,
    y2: 445.67,
    xlinkHref: "#Gradiente_sem_nome_7"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "Gradiente_sem_nome_7-4",
    x1: 1314.96,
    y1: 826.29,
    x2: 1314.96,
    y2: 445.66,
    xlinkHref: "#Gradiente_sem_nome_7"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "Gradiente_sem_nome_7-5",
    x1: 1579.15,
    y1: 826.26,
    x2: 1579.15,
    y2: 445.66,
    xlinkHref: "#Gradiente_sem_nome_7"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "Gradiente_sem_nome_7-6",
    x1: 1293.09,
    y1: 826.29,
    x2: 1293.09,
    y2: 445.66,
    xlinkHref: "#Gradiente_sem_nome_7"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "Gradiente_sem_nome_7-7",
    x1: 1440.55,
    y1: 826.29,
    x2: 1440.55,
    y2: 445.66,
    xlinkHref: "#Gradiente_sem_nome_7"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "Gradiente_sem_nome_7-8",
    x1: 1410.2,
    y1: 826.29,
    x2: 1410.2,
    y2: 445.67,
    xlinkHref: "#Gradiente_sem_nome_7"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "Gradiente_sem_nome_7-9",
    x1: 1591,
    y1: 826.29,
    x2: 1591,
    y2: 445.66,
    xlinkHref: "#Gradiente_sem_nome_7"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "Gradiente_sem_nome_7-10",
    x1: 1618.61,
    y1: 826.29,
    x2: 1618.61,
    y2: 445.67,
    xlinkHref: "#Gradiente_sem_nome_7"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "Gradiente_sem_nome_7-11",
    x1: 1530.35,
    y1: 826.29,
    x2: 1530.35,
    y2: 445.67,
    xlinkHref: "#Gradiente_sem_nome_7"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "Gradiente_sem_nome_7-12",
    x1: 1604.41,
    y1: 826.29,
    x2: 1604.41,
    y2: 445.66,
    xlinkHref: "#Gradiente_sem_nome_7"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "Gradiente_sem_nome_7-13",
    x1: 1554.35,
    y1: 826.29,
    x2: 1554.35,
    y2: 445.66,
    xlinkHref: "#Gradiente_sem_nome_7"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "Gradiente_sem_nome_7-14",
    x1: 1515.31,
    y1: 826.28,
    x2: 1515.31,
    y2: 445.6,
    xlinkHref: "#Gradiente_sem_nome_7"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "Gradiente_sem_nome_7-15",
    x1: 1566.74,
    y1: 826.29,
    x2: 1566.74,
    y2: 445.66,
    xlinkHref: "#Gradiente_sem_nome_7"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "Gradiente_sem_nome_7-16",
    x1: 1621.78,
    y1: 826.3,
    x2: 1621.78,
    y2: 445.66,
    xlinkHref: "#Gradiente_sem_nome_7"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "Gradiente_sem_nome_7-17",
    x1: 1578.39,
    y1: 826.29,
    x2: 1578.39,
    y2: 445.67,
    xlinkHref: "#Gradiente_sem_nome_7"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "Gradiente_sem_nome_7-18",
    x1: 768.94,
    y1: 826.28,
    x2: 768.94,
    y2: 445.62,
    xlinkHref: "#Gradiente_sem_nome_7"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "Gradiente_sem_nome_7-19",
    x1: 620.38,
    y1: 826.29,
    x2: 620.38,
    y2: 445.66,
    xlinkHref: "#Gradiente_sem_nome_7"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "Gradiente_sem_nome_7-20",
    x1: 753.79,
    y1: 826.29,
    x2: 753.79,
    y2: 445.66,
    xlinkHref: "#Gradiente_sem_nome_7"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "Gradiente_sem_nome_7-21",
    x1: 645.43,
    y1: 826.29,
    x2: 645.43,
    y2: 445.67,
    xlinkHref: "#Gradiente_sem_nome_7"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "Gradiente_sem_nome_7-22",
    x1: 565.01,
    y1: 826.3,
    x2: 565.01,
    y2: 445.67,
    xlinkHref: "#Gradiente_sem_nome_7"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "Gradiente_sem_nome_7-23",
    x1: 686.76,
    y1: 826.29,
    x2: 686.76,
    y2: 445.67,
    xlinkHref: "#Gradiente_sem_nome_7"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "Gradiente_sem_nome_7-24",
    x1: 804.44,
    y1: 826.29,
    x2: 804.44,
    y2: 445.67,
    xlinkHref: "#Gradiente_sem_nome_7"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "Gradiente_sem_nome_7-25",
    x1: 666.81,
    y1: 826.29,
    x2: 666.81,
    y2: 445.67,
    xlinkHref: "#Gradiente_sem_nome_7"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "Gradiente_sem_nome_7-26",
    x1: 619.95,
    y1: 826.29,
    x2: 619.95,
    y2: 445.66,
    xlinkHref: "#Gradiente_sem_nome_7"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "Gradiente_sem_nome_7-27",
    x1: 582.08,
    y1: 826.29,
    x2: 582.08,
    y2: 445.67,
    xlinkHref: "#Gradiente_sem_nome_7"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "Gradiente_sem_nome_7-28",
    x1: 537.02,
    y1: 826.29,
    x2: 537.02,
    y2: 445.66,
    xlinkHref: "#Gradiente_sem_nome_7"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "Gradiente_sem_nome_7-29",
    x1: 578.65,
    y1: 826.29,
    x2: 578.65,
    y2: 445.67,
    xlinkHref: "#Gradiente_sem_nome_7"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "Gradiente_sem_nome_7-30",
    x1: 501.34,
    y1: 826.29,
    x2: 501.34,
    y2: 445.67,
    xlinkHref: "#Gradiente_sem_nome_7"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "Gradiente_sem_nome_7-31",
    x1: 647.17,
    y1: 826.28,
    x2: 647.17,
    y2: 445.57,
    xlinkHref: "#Gradiente_sem_nome_7"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "Gradiente_sem_nome_7-32",
    x1: 491.91,
    y1: 826.29,
    x2: 491.91,
    y2: 445.67,
    xlinkHref: "#Gradiente_sem_nome_7"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "Gradiente_sem_nome_7-33",
    x1: 478.32,
    y1: 826.22,
    x2: 478.32,
    y2: 445.74,
    xlinkHref: "#Gradiente_sem_nome_7"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "Gradiente_sem_nome_7-34",
    x1: 540.96,
    y1: 826.29,
    x2: 540.96,
    y2: 445.67,
    xlinkHref: "#Gradiente_sem_nome_7"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "Gradiente_sem_nome_6",
    x1: 1289.85,
    y1: 513.9,
    x2: 1427.04,
    y2: 513.9,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#2c764f"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.33,
    stopColor: "#2c7b4c"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.71,
    stopColor: "#2b8944"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#2b993a"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "Gradiente_sem_nome_5",
    x1: 1090.56,
    y1: 415.74,
    x2: 1226.16,
    y2: 500.17,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#2b993a"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#2c764f"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "Gradiente_sem_nome_5-2",
    x1: 1357.92,
    y1: 335.27,
    x2: 1102.73,
    y2: 1155.18,
    xlinkHref: "#Gradiente_sem_nome_5"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "Gradiente_sem_nome_4",
    x1: 1078.4,
    y1: 443.98,
    x2: 1200.39,
    y2: 225.84,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#fead02"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#fdcc23"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "Gradiente_sem_nome_4-2",
    x1: 692.75,
    y1: 557.13,
    x2: 631.04,
    y2: 310.29,
    xlinkHref: "#Gradiente_sem_nome_4"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "Gradiente_sem_nome_4-3",
    x1: 934.91,
    y1: 650.23,
    x2: 732.56,
    y2: 127.85,
    xlinkHref: "#Gradiente_sem_nome_4"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "Gradiente_sem_nome_2",
    x1: 936.26,
    y1: 330.97,
    x2: 983.62,
    y2: 510.35,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#f6ead4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#b4583d"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "Gradiente_sem_nome_4-4",
    x1: 643.82,
    y1: 641.89,
    x2: 728.68,
    y2: 641.89,
    xlinkHref: "#Gradiente_sem_nome_4"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "Gradiente_sem_nome_2-2",
    x1: 833.05,
    y1: 576.35,
    x2: 666.57,
    y2: 882.03,
    xlinkHref: "#Gradiente_sem_nome_2"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "Gradiente_sem_nome_2-3",
    x1: 1060.31,
    y1: 384.28,
    x2: 1403.31,
    y2: 311.09,
    xlinkHref: "#Gradiente_sem_nome_2"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "Gradiente_sem_nome_2-4",
    x1: 1222.67,
    y1: 345.42,
    x2: 1301.6,
    y2: 191.86,
    xlinkHref: "#Gradiente_sem_nome_2"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "Gradiente_sem_nome_2-5",
    x1: 1263.12,
    y1: 664.7,
    x2: 1464.04,
    y2: 825.43,
    xlinkHref: "#Gradiente_sem_nome_2"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "Gradiente_sem_nome_3",
    x1: 1289.85,
    y1: 649.14,
    x2: 1427.04,
    y2: 649.14,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#2c764f"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#2b993a"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "Gradiente_sem_nome_2-6",
    x1: 688.9,
    y1: 336.34,
    x2: 1007.99,
    y2: 282.93,
    xlinkHref: "#Gradiente_sem_nome_2"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "Gradiente_sem_nome_2-7",
    x1: 830.63,
    y1: 170.37,
    x2: 835.07,
    y2: 284.86,
    xlinkHref: "#Gradiente_sem_nome_2"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "Gradiente_sem_nome_2-8",
    x1: 931.02,
    y1: 166.48,
    x2: 935.46,
    y2: 280.96,
    xlinkHref: "#Gradiente_sem_nome_2"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "Gradiente_sem_nome_2-9",
    x1: 848.84,
    y1: 371.27,
    x2: 924.7,
    y2: 65.86,
    xlinkHref: "#Gradiente_sem_nome_2"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "Gradiente_sem_nome_2-10",
    x1: 1155.87,
    y1: 333.47,
    x2: 1130.04,
    y2: 495.64,
    xlinkHref: "#Gradiente_sem_nome_2"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Layer_2",
    "data-name": "Layer 2"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Layer_1-2",
    "data-name": "Layer 1"
  }, /*#__PURE__*/React.createElement("polygon", {
    className: "cls-1",
    points: "1042.76 694.23 1026.12 677.59 1009.64 677.59 1042.76 710.7 1075.87 677.59 1059.4 677.59 1042.76 694.23"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M721,164.56c-19.36-23.06-34.76-56.27-19.62-82.3C711.63,64.59,733.52,56.36,754,56.8s39.95,8.07,59,15.59l127.31,50.37c23,9.12,49,21.3,55.47,45.22,14.46,53.13-70.39,91.45-112.72,87.44C822.91,249.73,758.92,209.75,721,164.56Zm-98.28,463c34.79,16.62,66.39,15.36,103.7,17.78,58.47,3.79,115.6,24.83,171.8,40.2,36,9.87,72.33,19.77,109.57,22.73,59.42,4.72,118.64-8.39,176.8-21.41,38.54-8.64,77.34-17.35,113.62-33a320.24,320.24,0,0,0,139.14-116.13c37.86-57,56.37-124.53,88.71-184.82,25.83-48.14,60.43-91.55,81.94-141.77s28-111.68-2.33-157.13C1566-5.42,1476.76-13.6,1413.07,18.68s-106.58,94.14-142.32,156c-10.88,18.81-21.63,38.21-37.69,52.85s-38.78,23.92-59.74,18.19c-31.37-8.59-48.75-46.72-80.76-52.48-23.64-4.26-46.58,11.24-62,29.64s-26.58,40.41-44,57C946,318.4,881.14,318.11,828.36,299.52s-98.91-52.19-150.15-74.67-113.36-32.65-161.45-4C461,254,443.42,328.4,452,392.74,464.34,491.4,533.1,584.73,622.69,627.51ZM1058,787.61c35.12,18.13,67.73,18.26,106,22.32,60.07,6.35,118,29.89,175.24,47.72,36.7,11.44,73.66,22.94,111.9,27.53,61,7.33,122.56-3.16,183-13.62,40.07-6.93,80.4-13.93,118.43-27.94,59-21.73,111.18-60.41,148.28-109.9,41.43-55.27,63.38-121.93,99.26-180.75,28.66-47,66.15-88.81,90.45-138s33.57-110.35,4.3-157.1C2056.62,196.74,1965,184.65,1898,214.1s-113.79,89.37-153.24,149.55c-12,18.32-23.91,37.23-41.07,51.15s-41,22.19-62.32,15.54c-31.94-10-48.22-48.82-80.94-56-24.17-5.3-48.46,9.18-65.16,26.88s-29.1,39.2-47.73,55C1404.19,493,1337.35,489.86,1283.79,469s-99.66-56.49-151.48-81.2-115.37-37.62-166.12-11.14c-58.87,30.7-80.14,104.26-74,168.92C900.64,644.66,967.49,740.92,1058,787.61ZM166.8,823.4c35.13,18.13,67.73,18.26,106.06,22.32,60.07,6.35,118,29.89,175.24,47.72C484.79,904.88,521.76,916.38,560,921c61,7.33,122.56-3.16,183-13.62,40.06-6.93,80.4-13.93,118.43-27.94,59-21.73,111.18-60.41,148.28-109.9,41.43-55.27,63.37-121.93,99.26-180.75,28.65-47,66.14-88.81,90.45-138s33.57-110.35,4.3-157.1c-38.26-61.1-129.87-73.19-196.85-43.74S893.1,339.26,853.65,399.44c-12,18.32-23.91,37.23-41.08,51.15s-41,22.19-62.32,15.54c-31.93-10-48.22-48.82-80.93-56-24.18-5.3-48.46,9.18-65.16,26.88s-29.1,39.2-47.73,55C513,528.79,446.21,525.65,392.64,504.75S293,448.26,241.17,423.55,125.79,385.93,75.05,412.41C16.18,443.11-5.09,516.67,1,581.33,9.5,680.45,76.35,776.71,166.8,823.4ZM1547.53,393.28c4.81,2.31,10.47,1.25,15.69.15,8.38-1.77,17-3.67,23.94-8.78s11.46-14.37,8.46-22.4c-3.9-10.44-18.53-13.08-28.49-8.09s-14.93,15.92-22.07,24.48C1541.64,382.73,1542.73,391,1547.53,393.28ZM614.77,132c-13.89-.67-31.13.59-36.76,13.31-4.22,9.53,1.17,21.11,9.55,27.3,16,11.81,63.55,23.88,76.75,2.55C683.15,144.76,635,133,614.77,132ZM353.32,413.18c-13.89-.68-31.13.59-36.76,13.31-4.21,9.53,1.17,21.11,9.55,27.29,16,11.82,63.55,23.89,76.76,2.56C421.7,425.91,373.56,414.16,353.32,413.18Zm1296.07,27.51c-13.89-.67-31.13.59-36.76,13.31-4.22,9.53,1.17,21.11,9.55,27.3,16,11.82,63.55,23.88,76.75,2.55C1717.76,453.42,1669.63,441.67,1649.39,440.69Zm49.13-101.88c-13.88-.68-31.13.59-36.76,13.31-4.21,9.53,1.17,21.11,9.56,27.29,16,11.82,63.54,23.89,76.75,2.56C1766.9,351.54,1718.76,339.79,1698.52,338.81ZM1061.28,60.41c-13.89-.67-31.13.59-36.76,13.31-4.22,9.53,1.17,21.11,9.55,27.29,16,11.82,63.55,23.89,76.75,2.56C1129.65,73.14,1081.52,61.39,1061.28,60.41Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M1461.1,512c-.25,2.67-.51,5.39-.76,8.15s-.49,5.56-.8,8.36c-.62,5.59-1.41,11.2-2.41,16.8s-2.23,11.19-3.63,16.78-2.79,11.33-4.59,16.92c36-56.71,78.73-109,126.13-156.52l4.22-.34a305.86,305.86,0,0,0-30.78,3.89c-4.85.83-10.2,1.82-16,3s-11.78,2.89-18.28,4.69a344.18,344.18,0,0,0-42.74,14.61c-3.27,1.35-6.62,2.8-10,4.27C1462.14,469.52,1462.87,490.4,1461.1,512Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M1286.24,641.21c1.76,4.3,3.83,9.79,6.44,16.44,5.15,13.25,11.11,30.49,16.91,50.17A589.63,589.63,0,0,1,1325.51,773c1,5.81,2,11.69,2.68,17.6s1.64,12,2.16,18,1,12.16,1.11,18.27c.1,3.07,0,6.11.1,9.21s.08,6.21,0,9.32c1-3.67,1.82-7.36,2.85-11l3.24-10.89,6.49-21.8c2.29-7.22,4.87-14.36,7.28-21.54l3.69-10.76L1357,764l2.06-5.3a219,219,0,0,0,9.83-33.89A227,227,0,0,0,1374,691c2.47-22.32,1.73-44.87.52-66-.37-5.32-.85-10.58-1.4-15.77s-1.14-10.29-1.68-15.2c-1.14-9.88-2.54-19.39-4.06-28.34-.76-4.47-1.55-8.81-2.35-13s-1.51-8.1-2.2-11.83c-1.45-7.51-2.91-14.26-4.25-20.05l5-4.71c2.25,9.57,4.91,22.11,7.34,36.55,2.67,14.59,5.35,31.22,7,48.75.88,8.79,1.91,18,2.42,27.31q.42,7,.58,14t.2,14.3a289.1,289.1,0,0,1-1.1,29.08q-.71,7.23-1.44,14.68t-2.15,14.74l5.63-13c1.86-4.33,3.73-8.66,5.84-12.87l12.28-25.46c4.19-8.44,8.79-16.67,13.17-25,2.24-4.15,4.37-8.35,6.69-12.45l7.14-12.2a164,164,0,0,0,10-20.38,168.38,168.38,0,0,0,7.66-20.68,281.93,281.93,0,0,0,8.8-42c.93-6.93,1.33-14,1.94-20.67s.84-13.35,1-19.82c.25-12.92-.3-25.25-.7-35.9-2.64,1.19-5.27,2.37-8,3.65-7.92,3.94-15.89,8.36-24.06,13.09-16.55,9.32-32.45,21-48.61,33.89-31.44,26.4-60.8,60.32-81.47,100.71a300,300,0,0,0-14.19,33.18c1-2.46,1.93-4.94,2.9-7.41C1283.16,633.87,1284.49,636.92,1286.24,641.21Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "M1466.87,571c4.66-3.32,9.49-6.3,14.31-9.07s9.7-5.27,14.57-7.54c2.43-1.13,4.86-2.21,7.28-3.22s5-1.88,7.44-2.74a209,209,0,0,1,54.62-11.25c-.3,1.78-.6,3.59-.9,5.4a194.23,194.23,0,0,0-32.91,5.38c-5.88,1.45-11.94,3.19-18.08,5.27a149.94,149.94,0,0,0-18.16,7.59,189,189,0,0,0-18,10q-2.22,1.4-4.42,2.86c-1.42,1-2.81,2.06-4.21,3.13-2.78,2.14-5.53,4.38-8.22,6.73a161.45,161.45,0,0,0-15.42,15.42A143.76,143.76,0,0,0,1432,617.4l-7.09,12.13c-2.31,4.07-4.43,8.25-6.66,12.37-4.35,8.3-8.92,16.48-13.08,24.87L1393,692.08c-2.11,4.18-4,8.48-5.81,12.79l-5.6,12.89q4.47-6,9.24-11.48a122.23,122.23,0,0,1,10-10.49,231.32,231.32,0,0,1,21.65-18.09,131.42,131.42,0,0,1,11.39-7.63q5.82-3.55,11.63-6.71a225.56,225.56,0,0,1,23.09-11,277.78,277.78,0,0,1,43.36-13.14,289,289,0,0,1,33.67-4.67c1.06-4.11,2.08-8.21,3-12.33,4.3-16.08,7.13-32.75,10.34-48.46,1.5-7.94,2.74-15.9,4-23.65s2.59-15.18,3.67-22.57c2-14.92,4.14-28.62,5.73-41.28.8-6.32,1.48-12.37,2.11-18s1.39-10.69,1.94-15.41c1.43-12.17,2.22-21.37,2.6-26.4-47.1,47.24-89.6,99.19-125.35,155.56A171.86,171.86,0,0,1,1466.87,571Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M1316.23,943.65l-2.54,2.15S1314.58,945.06,1316.23,943.65Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-7",
    d: "M1579.26,422.18c0,.09-.09,1.25-.23,3.27C1579.18,423.42,1579.25,422.31,1579.26,422.18Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-8",
    d: "M1320.89,890.71c1.44-6.73,2.41-13.45,3.18-20.12,1-6.62,1.55-13.23,1.84-19.81s.2-13.17.09-19.66-.34-12.91-.88-19.32-1.3-12.79-2.25-19.11c-.75-6.25-1.68-12.46-2.77-18.59-2.12-12.25-5.19-24.35-7.82-35.7-2.81-11.41-6-22.37-9.23-32.64s-6.17-19.64-9.22-28.18c-5.93-17-11.61-30.27-14.49-37.32a339.74,339.74,0,0,0-18.73,91.47c-.88,20.68-.88,40.39,1.38,59.25,1,9.38,2.16,18.42,3.66,27.15,1.68,8.78,3.53,17.19,5.49,25.2a343.66,343.66,0,0,0,13.47,43.11q3.57,9.48,7,17.52c2.46,5.4,4.82,10.31,7,14.71a303.66,303.66,0,0,0,15,27.13l-2.22-3.61C1314.41,925,1317,907.72,1320.89,890.71Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-9",
    d: "M1544.11,639.86c-5.33.47-11.55,1.17-18.47,2.24-3.45.54-7.15,1.13-10.87,1.91s-7.55,1.69-11.52,2.72c-8,2-16.4,4.59-25.15,7.74-2.19.79-4.4,1.61-6.62,2.48s-4.34,1.83-6.52,2.81q-6.56,3-13.2,6.4a201.06,201.06,0,0,0-50.84,37.13,205.41,205.41,0,0,0-21,26.18,173.6,173.6,0,0,0-15.7,31.21l-2,5.27-1.83,5.34-3.66,10.7c-2.41,7.14-5,14.23-7.24,21.41L1343,825.06l-3.23,10.83c-1,3.63-1.88,7.3-2.83,10.94q2.14-4.1,4.44-8c1.55-2.63,3.31-5.15,5-7.65q5.19-7.49,10.82-14.34a161.41,161.41,0,0,1,11.7-13q6.24-6.1,12.68-11.59c16.82-14.73,35.81-25.51,52.63-33.64a281.06,281.06,0,0,1,45.49-16.23c6.06-1.64,11.5-2.69,15.67-3.46s7.13-1.19,8.74-1.4c3.61-6.21,7.1-12.51,10.35-19C1527.54,693.12,1536.88,666.67,1544.11,639.86Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-10",
    d: "M1465.79,751.91a249.45,249.45,0,0,0-25.35,9.7,277.56,277.56,0,0,0-27.53,14.56,202.61,202.61,0,0,0-27.63,20.07c-4.5,3.83-9,7.89-13.3,12.19-4.13,4.37-8.17,9-12.06,13.82s-7.62,9.92-11.17,15.22a170.29,170.29,0,0,0-9.35,16.78,196,196,0,0,0-7.79,18.12,171.61,171.61,0,0,0-5.27,19.49c-3.88,16.91-6.43,34.06-9.36,51.15,3.83-3.28,10.79-9.35,19.76-17.7,3.49-3.23,7.28-6.8,11.29-10.67,4.19-3.84,8.66-8,13.29-12.34,9.28-8.76,19-18.59,29.92-29,5.32-5.23,10.69-10.67,16-16.29,5.54-5.56,11.23-11.27,16.74-17.16,10.79-11.87,22.56-24,33-37,17-19.93,32.87-41.08,46.41-64.08-.88,1.45-1.74,2.9-2.65,4.33A235.91,235.91,0,0,0,1465.79,751.91Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-11",
    d: "M1639.51,732c-.26-3.62-.57-7.12-1-10.51-.17-1.13-.36-2.22-.55-3.32-3.53,2.14-7.61,4.6-11.71,7.46a156.48,156.48,0,0,0-12.38,9.69,103.48,103.48,0,0,0-11.53,12,66,66,0,0,0-4.93,7,62.25,62.25,0,0,0-4.27,7.7,399.23,399.23,0,0,1-20.62,38.76c10.9-11,23.61-19.45,35.78-26,6-3.32,11.83-6.12,17.06-8.45s9.72-4.25,13.27-5.6l-.4,2.6a252.64,252.64,0,0,0-36.65,17.76c-14.13,8.57-28.37,19.51-38.69,35-3.24,4.91-6.66,9.71-10,14.53-3.58,4.67-6.95,9.51-10.7,14.05,15.09-11.91,32.88-19.42,48-24.62a240,240,0,0,1,29.86-8.32c2-3,3.85-6,5.55-9.23a129.24,129.24,0,0,0,13.76-47.72A146.22,146.22,0,0,0,1639.51,732Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-12",
    d: "M1599.68,747.24c11.09-14.36,26.49-24.62,37.86-31.39-.25-1.39-.5-2.77-.77-4.11a144,144,0,0,0-4.45-16.89c-.81-2.48-1.6-4.79-2.38-6.91s-1.65-4.09-2.41-5.84c-3-7-5.23-10.8-5.25-10.84l.78,1.45A412.87,412.87,0,0,1,1599.68,747.24Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-13",
    d: "M1545.07,803.19a111,111,0,0,0-1.66-12.05,100.25,100.25,0,0,0-2.66-10.27,95.39,95.39,0,0,0-5-13.14,175.16,175.16,0,0,0-9.14,27.77c-1.72,6.35-2.87,12.88-4.11,19.06-.59,3.12-1.07,6.24-1.54,9.28s-1,6-1.37,8.85c-.74,5.84-1.5,11.21-2,16.16s-1,9.36-1.35,13c-.45,4.76-.68,8.33-.78,10.29,4.58-5,9.25-9.81,13.58-15C1543,841.05,1546.41,820.15,1545.07,803.19Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-14",
    d: "M1597.68,746.4a410.15,410.15,0,0,0,23.26-74.14c-1.56,1.19-4.38,3.38-8.06,6.45l-10,8.47c-3.77,3.24-7.78,6.9-12.18,10.8-.93.84-1.86,1.75-2.79,2.62C1594,711.37,1600.21,728.35,1597.68,746.4Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-15",
    d: "M1540.43,843.37c3.73-4.52,7.08-9.33,10.64-14,3.36-4.79,6.77-9.56,10-14.45,10.35-15.55,12.26-33.77,10.15-49.18a100.71,100.71,0,0,0-12-35.57,152.35,152.35,0,0,0-18.73,27.44c-1.35,2.53-2.59,5.1-3.76,7.69a103.15,103.15,0,0,1,9,27.08C1548.48,806.85,1548.59,825.89,1540.43,843.37Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-16",
    d: "M1515.29,873.86s0-.45,0-1.24C1515.3,873.4,1515.29,873.86,1515.29,873.86Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-17",
    d: "M1592.27,821.69c-4,1.29-8.1,2.77-12.32,4.48-17.06,6.82-35.43,16.4-49.37,32.46-4.35,5.2-9,10.08-13.65,15.06l-1.64.17s4.43-.35,11.91-1.78q2.82-.54,6.18-1.3t7-1.93a142,142,0,0,0,16.46-5.85c2.93-1.24,6-2.61,9.06-4.1s6.11-3.25,9.25-5.08a146.84,146.84,0,0,0,18.71-13,134.31,134.31,0,0,0,24.28-26.29c-2.88.65-8.31,1.82-15,3.75C1599.84,819.22,1596.22,820.4,1592.27,821.69Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-18",
    d: "M1621.27,672l1-.75S1621.9,671.53,1621.27,672Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-19",
    d: "M1571.87,757.29c2.76,12.53,3.55,27.74-1.23,42.41a396.09,396.09,0,0,0,20.51-38.55,55.85,55.85,0,0,0,3.06-8.2,63.53,63.53,0,0,0,1.55-8.34,60.19,60.19,0,0,0-.35-16.18,70.59,70.59,0,0,0-3.73-14.53,79.88,79.88,0,0,0-5.35-11.84c-.73.69-1.46,1.34-2.19,2.05-2.25,2.1-4.55,4.26-6.8,6.5-4.4,4.51-9.15,9.15-13.42,14.14q-1.67,1.86-3.3,3.76a116.62,116.62,0,0,1,5.88,11.92A112.24,112.24,0,0,1,1571.87,757.29Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-20",
    d: "M770.12,911.71l-2.35-2.4C769.29,910.88,770.12,911.71,770.12,911.71Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-21",
    d: "M674.88,543.88c-1.17-5.58-2.06-11.19-2.72-16.81s-1.43-11.06-1.81-16.58-.59-11-.62-16.48q0-4.1.08-8.15t.1-7.95c.5-21,3.35-41.11,5.75-57.35-3.09-1.77-6.17-3.51-9.19-5.15a337.23,337.23,0,0,0-39.76-18.51q-9.13-3.63-17.17-6.43c-5.48-1.77-10.54-3.29-15.14-4.59a294.69,294.69,0,0,0-29.31-7l4,.77C609.91,430.57,645.83,485.46,674.88,543.88Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-22",
    d: "M675.37,477.42c-.09,6.5-.42,13.38-.23,20.17A270.7,270.7,0,0,0,679.39,539a163.21,163.21,0,0,0,5.31,20.75,158.38,158.38,0,0,0,7.62,20.69L698,593c1.84,4.2,3.49,8.47,5.24,12.7,3.4,8.5,7,16.91,10.24,25.48L722.84,657c1.62,4.28,3,8.65,4.38,13l4.18,13.09q-.55-7.25-.64-14.46c0-4.82,0-9.63,0-14.34.12-9.47.76-18.89,1.81-28.21l1.62-13.79q.85-6.82,1.95-13.52c1.42-8.91,3.33-17.73,5.06-26.13,3.38-16.77,7.65-32.56,11.69-46.38,3.81-13.7,7.66-25.53,10.81-34.54l4.31,5.05c-1.88,5.45-4,11.82-6.14,18.93q-1.56,5.29-3.32,11.2T755,539.17c-2.36,8.49-4.67,17.54-6.76,27q-1.53,7-3.14,14.51t-2.93,15.1c-3.28,20.3-6.22,42-6,63.83a220.74,220.74,0,0,0,1.65,33.23,211.45,211.45,0,0,0,6.21,33.7l1.47,5.33,1.27,5.37L749.26,748c1.65,7.17,3.45,14.32,5,21.52l4.19,21.7,2.1,10.84c.65,3.63,1.14,7.28,1.71,10.92.24-3,.55-6,.91-9s.59-5.94,1-8.89c.73-5.9,1.69-11.76,2.82-17.56s2.6-11.59,3.82-17.22S773.47,749,775,743.51a567.54,567.54,0,0,1,21.71-61.41c7.53-18.44,15-34.5,21.27-46.79s10.63-20.52,12.41-23.49c.69,2.49,1.38,5,2.07,7.45a292,292,0,0,0-10.43-33.41c-15.94-41-40.87-76.63-68.55-105.25C739.23,466.51,725.06,453.67,710,443c-7.4-5.4-14.64-10.47-21.89-15.09-2.46-1.5-4.87-2.9-7.3-4.33-1.49,10.26-3.28,22.1-4.37,34.61C675.94,464.44,675.55,470.88,675.37,477.42Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-23",
    d: "M648.58,612.85A221.42,221.42,0,0,1,669.8,625.8q5.31,3.63,10.58,7.64A130.39,130.39,0,0,1,690.64,642a227.06,227.06,0,0,1,19.15,19.63,116.45,116.45,0,0,1,8.63,11.13q4.07,5.79,7.81,12l-4.16-13c-1.36-4.34-2.73-8.68-4.35-12.94l-9.31-25.67c-3.2-8.52-6.8-16.88-10.19-25.33-1.74-4.21-3.37-8.46-5.2-12.62l-5.64-12.44a140.8,140.8,0,0,0-10.53-19.17,156.88,156.88,0,0,0-13.36-16.46c-9.27-10.29-20.31-18.56-31.36-25.46a148.92,148.92,0,0,0-16.78-9.19c-5.72-2.64-11.4-4.94-16.93-6.95a190.66,190.66,0,0,0-31.27-8.59c-.1-1.78-.21-3.56-.31-5.31a204.61,204.61,0,0,1,51.64,16.51c2.3,1.09,4.63,2.2,6.92,3.41s4.47,2.52,6.71,3.86c4.47,2.69,8.92,5.61,13.31,8.77s8.75,6.54,12.91,10.22,8,7.73,11.71,12c-28.88-58.07-64.59-112.63-105.13-163.21-.15,4.89-.35,13.86-.25,25.77,0,4.62.13,9.68.27,15.1s.05,11.43.17,17.63c.23,12.4.89,25.87,1.29,40.51.28,7.26.68,14.68,1.23,22.2s.78,15.46,1.43,23.29c1.5,15.54,2.56,32,5.1,48q.79,6.13,1.72,12.25A282.65,282.65,0,0,1,608,595.77,271.11,271.11,0,0,1,648.58,612.85Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-24",
    d: "M564.94,382.24c.09-2.12.14-3.34.14-3.34S565,380.07,564.94,382.24Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-25",
    d: "M759.65,839a188.66,188.66,0,0,0-5.82-18.26,162.93,162.93,0,0,0-7.45-17.12q-4.38-8.21-9.35-15.8T726.69,773.3c-3.79-4.58-7.71-8.94-11.69-13.07a197.71,197.71,0,0,0-24.78-22.1A270.53,270.53,0,0,0,665,721.35a243.41,243.41,0,0,0-23.57-11.87,230.64,230.64,0,0,0-33-12c-.74-1.48-1.44-3-2.15-4.48,10.86,23.64,24.17,45.72,38.69,66.7,8.85,13.58,19.07,26.48,28.37,39C678.15,805,683.12,811,687.94,817c4.64,5.95,9.32,11.73,14,17.31,9.51,11.12,18.05,21.56,26.2,30.92,4.07,4.68,8,9.08,11.69,13.19s6.86,7.93,9.93,11.38c7.9,8.92,14.06,15.43,17.46,19-1.24-16.8-2.11-33.63-4.27-50.35A168.87,168.87,0,0,0,759.65,839Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-26",
    d: "M815,654.46c-3.79,7.94-7.53,16.72-11.67,26.31s-8.28,19.88-12.1,30.63c-3.65,10.71-7.78,22.11-11,33.74q-2.48,8.73-4.47,17.7c-1.53,6-2.88,12.11-4,18.25s-2,12.34-2.7,18.59-1.47,12.63-1.78,19-.38,12.84-.09,19.33c.11,6.52.42,13.11,1.18,19.75,2.18,16.82,3.06,33.75,4.31,50.66l-2.49,3.28a295.79,295.79,0,0,0,17.08-24.83c2.54-4,5.28-8.57,8.16-13.56q4.08-7.46,8.42-16.28a335.09,335.09,0,0,0,17.1-40.39q4-11.31,7.71-23.81c2.28-8.28,4.25-16.9,6.13-25.87,4-18,5.9-37,7-57.05a330.81,330.81,0,0,0-9.14-90.09C829.15,626.36,822.36,638.63,815,654.46Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-27",
    d: "M671.27,719c15.49,9.52,32.79,21.8,47.65,37.67,3.79,3.95,7.52,8.1,11.14,12.44a155.06,155.06,0,0,1,10.07,13.72q4.79,7.15,9.1,14.89c1.41,2.58,2.87,5.2,4.12,7.88s2.41,5.42,3.53,8.19c-.57-3.61-1.06-7.24-1.7-10.85l-2.08-10.78-4.17-21.56c-1.52-7.17-3.31-14.27-4.94-21.4l-2.51-10.7-1.26-5.34-1.47-5.29a168.54,168.54,0,0,0-12.15-31.72,199.34,199.34,0,0,0-17.7-27.37,196.22,196.22,0,0,0-45.48-40.94c-16-10.79-32.92-18.4-47.86-24q-5.61-2.08-10.87-3.79c-3.51-1.13-7-2.07-10.31-3-6.59-1.73-12.53-3-17.64-4,4.32,26.69,10.74,53.27,20.84,79.14,2.51,6.61,5.26,13.07,8.16,19.44a204.68,204.68,0,0,1,23.13,7.14A275.59,275.59,0,0,1,671.27,719Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-28",
    d: "M593.12,779.84a126.59,126.59,0,0,0,.81,14.52A92.64,92.64,0,0,0,597.1,810c.76,2.65,1.63,5.34,2.62,8s2.26,5.21,3.57,7.8,2.77,5.16,4.36,7.69a76.67,76.67,0,0,0,5.38,7.21,92.33,92.33,0,0,0,6.26,6.79,79.66,79.66,0,0,0,7.34,6c6.5,4.88,13.39,9.2,20.16,13.68-.69-2.26-2-6.38-3.86-11.81l-2.44-6.85c-.85-2.49-1.77-5.18-2.75-8l-6.67-18.29c-1.22-3.27-2.5-6.59-3.87-9.94s-2.62-6.94-4.07-10.41c-3-6.85-5.82-14.2-9.29-21.11a220,220,0,0,0-16.69-30.05A106,106,0,0,0,594,767.19,111.44,111.44,0,0,0,593.12,779.84Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-29",
    d: "M554.88,756.41a92.68,92.68,0,0,0,5.72,28.88,95,95,0,0,0,7,14,80.51,80.51,0,0,0,10.23,12.76c5,5,10.21,9.76,15.37,14.57l8,6.92c2.65,2.33,5.34,4.62,8.14,6.76a78.49,78.49,0,0,1-8.93-14.42,82.21,82.21,0,0,1-5.78-15.14c-3-10-3.9-20.19-4.06-28.91a128.52,128.52,0,0,1,2.06-22.46,95,95,0,0,1,2.77-11.29c-1.91-2.73-3.88-5.43-6-8.06a187.3,187.3,0,0,0-27.24-27.89,112.46,112.46,0,0,0-5.31,18.61A106.51,106.51,0,0,0,554.88,756.41Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-30",
    d: "M544.68,825.08c19.28,2.74,42.16,7.3,63.07,17.3-2.82-2.16-5.53-4.46-8.2-6.81l-8.06-7c-5.19-4.85-10.44-9.64-15.46-14.67a103.69,103.69,0,0,0-12.53-10.79,107.33,107.33,0,0,0-13.42-8.82c-9-5.45-18.76-9.59-28-13.29-9.44-3.52-18.41-6.53-26.63-8.83s-15.31-4.14-20.82-5.32l-1-3.06c4.52,1,10.38,2.39,17,4.28s14.34,4,22.12,6.79c3.91,1.39,8,2.79,12.09,4.42s8,3.45,12.21,5.29,8.2,3.92,12.16,6.2,8,4.61,11.82,7.31a391.36,391.36,0,0,1-32.89-41.5,75.52,75.52,0,0,0-6.65-8.3,77.7,77.7,0,0,0-7.23-7.39,134.79,134.79,0,0,0-16-12.18c-5.63-3.52-11.12-6.71-16.54-9.45s-10.75-5-15.33-7c0,1.36-.07,2.72-.07,4.12.06,4.16.32,8.44.68,12.87a168.58,168.58,0,0,0,4.6,27.54c4.92,18.71,13.54,38.07,26.73,55,2.77,3.51,5.74,6.79,8.8,10,1.68,0,6.2.22,12.83.68S535.15,823.68,544.68,825.08Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-31",
    d: "M625.11,855.59c-2.61-1.89-5.31-3.58-8-5.18s-5.36-3.19-8.12-4.58-5.61-2.6-8.4-3.8-5.59-2.34-8.43-3.34-5.72-1.91-8.61-2.72-5.65-1.7-8.48-2.43c-5.64-1.47-11.42-2.51-16.78-3.61s-10.72-1.84-15.74-2.46-9.59-1.24-13.84-1.63c-8.39-.83-15.17-1-18.75-1.22a157.29,157.29,0,0,0,35.48,26.06,169.29,169.29,0,0,0,25.68,11c4.22,1.39,8.32,2.65,12.35,3.7s8.06,1.8,11.87,2.5a156.35,156.35,0,0,0,21.08,2.47q4.74.28,8.84.34t7.65-.23a139.36,139.36,0,0,0,14.47-1.34l-2,.27C638.58,864.85,631.65,860.51,625.11,855.59Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-32",
    d: "M517.59,731.09c-.46-2.64-.75-5.28-1-7.88a78.09,78.09,0,0,1,.21-15.09,95.57,95.57,0,0,1,6.36-25.24c-1.25-.86-2.5-1.77-3.74-2.6l-16.2-10.8-7.15-4.57-6.08-4c-4.83-3.11-8.53-5.34-10.56-6.53a401.46,401.46,0,0,0,40.12,84.51Q518.39,735,517.59,731.09Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-33",
    d: "M647.36,869.09s-.13-.48-.38-1.3C647.23,868.62,647.36,869.09,647.36,869.09Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-34",
    d: "M504.76,730c2.18,1.55,4.28,3.2,6.37,4.92s4.24,3.45,6.25,5.33A403.59,403.59,0,0,1,477,655.22l.73-1.84A137.94,137.94,0,0,0,473,667.13q-1,3.33-2,7.38c-.61,2.66-1.19,5.56-1.76,8.67a154.6,154.6,0,0,0-2.56,21.07c-.1,1.66-.17,3.37-.23,5.1a237.78,237.78,0,0,1,25,12.27C495.79,724.23,500.47,726.9,504.76,730Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-35",
    d: "M477.76,653.4l1.12.65Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-36",
    d: "M519,717.13a69,69,0,0,0,2.59,19.28A74.17,74.17,0,0,0,525,746a66.74,66.74,0,0,0,5.29,9.12A389.62,389.62,0,0,0,563,796.37a79.44,79.44,0,0,1-5.58-12.48A109.34,109.34,0,0,1,554,771.13a91.89,91.89,0,0,1-1.52-12.6,101.65,101.65,0,0,1-.07-11.95,127.39,127.39,0,0,1,3.11-20.94,133.59,133.59,0,0,1,4.8-15.13q-2.26-1.89-4.58-3.72c-5.9-5-12.37-9.51-18.32-14-3-2.22-6.14-4.33-9.16-6.41-1-.7-1.94-1.34-2.92-2a88,88,0,0,0-4.42,14.91A79.75,79.75,0,0,0,519,717.13Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-37",
    d: "M1269.16,183.65c-2.12-6.38-9.3-10.13-16.14-10.26s-13.38,2.64-19.43,5.77c-14.91,7.69-29,18.48-36,33.5s-5.28,34.81,7.46,45.62c-5.59.32-10,5.52-10.74,11s1.3,10.9,4.1,15.65,6.36,9.06,9,13.93,4.2,10.56,2.73,15.85c-2.62,9.37-13.44,13.95-18.91,22.05a22.3,22.3,0,0,0-.31,24c4.65,7.26,13.49,11.94,22,13.92A288,288,0,0,0,1313.13,380c9.07-1.11,18.41-2.79,25.92-7.91s18.66-14.54,16.06-23.14c-2.2-7.27-9.3-12.48-11-19.89-1.81-8,3.18-15.83,8.6-22s11.78-12.25,13.54-20.23c2.21-10-10.62-21.1-20.68-23.82,1.42-12.53-6.65-25.51-18.66-30-8.5-3.19-9.31-14.66-10.6-23.5C1312.89,185.85,1289.53,166.89,1269.16,183.65Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-38",
    d: "M1419.22,400.46c20.38,8.84,23.62,146.46,15,226.88,0,0-18.5-23.27-45.42-15.82V485Z"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-39",
    points: "1400.54 458.98 1388.77 611.52 1388.77 485 1400.54 458.98"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-40",
    d: "M1145.06,376c-21.72,4.95-31.8,63.35-31,129.17h59.46S1162.18,372.1,1145.06,376Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-41",
    d: "M1356.53,373.67c49.12,19.68,58.17,25.5,62.69,26.79s-8.4,69.87-22,93.42-7.81,48.11-30.73,83,33.07,177.38,33.07,267.68H1106.53s21.63-135.55,68.13-202.68,9.73-69.3-1.09-102.82S1159.32,410.65,1145.06,376c0,0,25.28-6.06,71.23-15.26S1356.53,373.67,1356.53,373.67Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-39",
    d: "M1123.82,765.92h220.23l-8.81-352.53H1154.35c7.27,42.72,11.24,100.92,19.22,125.68,10.82,33.52,47.59,35.69,1.09,102.82C1151.86,674.8,1135,724.15,1123.82,765.92Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-39",
    d: "M750,765.92c-3.53,51.07-6.11,78.65-6.11,78.65h270.23l-.5-75.85Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-42",
    d: "M1052.42,360.42c16.39,18.17,33.83,50.79,24.73,208.53,0,0-8.34,55.36-71.29,58.39,0,0,6.07-61.43,18.21-118.3S1052.42,360.42,1052.42,360.42Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-43",
    d: "M715.28,617.38c3.32-15.41,13.4-85.2,13.4-85.2l-22.2-171.76c-47.78,53-61.73,219.85-62.66,252.57C650.18,572,704.79,598.14,715.28,617.38Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-44",
    d: "M716.84,440.55,705.45,606.41c4.4,3.58,7.88,7.4,9.83,11,3.32-15.41,13.4-85.2,13.4-85.2Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-45",
    d: "M706.48,360.42s-8.32,58.64,22.2,171.76S750,765.92,750,765.92,769.38,793,863.73,793s149.84-24.31,149.84-24.31V606c0-51.42,57.35-189.25,38.85-245.62,0,0-41.63-45.14-164.65-45.14S706.48,360.42,706.48,360.42Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-44",
    d: "M1013.57,765.92V606c0-39,32.9-127.5,40.81-192.65H749.58l-7.79,181.19c14.32,91,8.16,171.34,8.16,171.34Z"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 755.72,
    y: 416.33,
    width: 579.52,
    height: 334.15
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-37",
    x: 770.12,
    y: 430.73,
    width: 550.72,
    height: 305.35
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-46",
    d: "M919.44,416.33s26.25-26.24,31.88-26.55,34.07,2.47,48.13,26.55H983.82s-8.12,5.33-11.56,6.89S911.62,426.63,919.44,416.33Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-47",
    d: "M728.68,669.92c-3.89-15.14-3.57-31.73-13.4-52.54-10.49-19.24-65.1-45.4-71.46-4.39.94,29.26,20.37,57.54,41,79.53C666.77,674.26,713,635.44,728.68,669.92Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-48",
    d: "M819,750.48c3.29-4.11-3.68-7.79-8.12-9.62a14,14,0,0,1-5.71-4.27,14,14,0,0,0-4.85-3.89L773,719.5a26.5,26.5,0,0,0-11.51-2.63H754s-21.47-31.81-25.36-47c-15.69-34.48-61.91,4.34-43.84,22.6a319.2,319.2,0,0,0,49.88,42.74l32.78,30.66a9.57,9.57,0,0,0,8.27,2.43l50.52-9.18a9.89,9.89,0,0,0,7.68-6.82l.57-1.87Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-49",
    d: "M1287.09,261.2a11.17,11.17,0,0,1,15.4,10c1.32,40.28,7.39,66.38,13.52,77.26,6.92,12.28,40.52,25.21,40.52,25.21s-14.21,35.54-77.55,35.54-62.69-48.47-62.69-48.47,28.44-5.17,29.09-13.57S1237,281.9,1237,281.9Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-50",
    d: "M1316,348.46c-6-10.71-12-36.16-13.46-75.38A12.55,12.55,0,0,0,1285.2,262L1237,281.9s6.34,39.89,8,57.78c17.27,7,30.31,8.69,46-7.6,5.12-5.29,12.85,11.93,29.83,22.05A23.27,23.27,0,0,1,1316,348.46Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-51",
    d: "M1307.25,260.76c-6.73-4.24-11.21-11.19-15.27-18s-8.06-14-14.26-18.94c-3.85-3.09-8.4-5.22-12.12-8.45s-6.63-8.13-5.54-12.94a32.83,32.83,0,0,1-22.1,17.3c-2.07.45-4.29.75-5.94,2.08-2.67,2.15-2.83,6.05-3.3,9.44a34.12,34.12,0,0,1-15,23.41c4.35,27.89,10.88,50.78,31.3,62.45,22.13,12.65,52.93-9.42,60.11-44.85,1.26,2,2.93,3.29,4.83,3.42,4.07.29,7.8-4.7,9-11.52A22.12,22.12,0,0,1,1307.25,260.76Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-52",
    d: "M1367.48,669.85c-7.75,18.4-31.9,47-31.9,47h-7.41a26.53,26.53,0,0,0-11.51,2.63l-27.38,13.2a14,14,0,0,0-4.85,3.89,14.1,14.1,0,0,1-5.71,4.27c-4.44,1.83-11.41,5.51-8.12,9.62h-15.51l.57,1.87a9.89,9.89,0,0,0,7.68,6.82l50.52,9.18a9.58,9.58,0,0,0,8.27-2.43l32.77-30.66c14.68-14.86,31.32-30.82,45.57-47C1401.88,673.39,1380.45,661.52,1367.48,669.85Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-53",
    d: "M1388.77,611.52c-9.08,6.92-12.16,34.56-20.69,56.83-.18.49-.39,1-.6,1.5,13-8.33,34.4,3.54,33,18.37,18-20.46,32.15-41.32,33.72-60.88C1434.19,627.34,1415.69,604.07,1388.77,611.52Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-54",
    d: "M839.54,252.35V334.1a18,18,0,0,0,6.2,13.72c6.64,5.67,19.52,12.6,42.75,12.6,25.26,0,37.45-9.17,42.93-15.72a17.78,17.78,0,0,0,4-11.42V242.55Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-50",
    d: "M931.42,344.7a17.78,17.78,0,0,0,4-11.42V242.55l-95.89,9.8v41c19.74,16.67,62.84,24.26,68.58,34.12,4.66,8,6.32,18.06,5.65,28.94C922.75,353.19,928.23,348.51,931.42,344.7Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-55",
    d: "M843,227.58c2.06,9.87-.79,18.82-6.36,20s-11.74-5.91-13.8-15.78.79-18.81,6.36-20S841,217.71,843,227.58Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-56",
    d: "M923.39,227.58c-2,9.87.79,18.82,6.36,20s11.74-5.91,13.8-15.78-.79-18.81-6.36-20S925.45,217.71,923.39,227.58Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-57",
    d: "M839.54,228.66v23.69c0,10.83,21,47.12,50,47.12s45.85-34.6,45.85-47.54V178.06S928.69,153,887.49,153s-48,23.77-48,23.77Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-37",
    d: "M935.4,211.73a6.32,6.32,0,0,1,1.79.08,6.46,6.46,0,0,1,3.3,1.9c.75-4.51.61-16.79,1.72-20,2.38-6.89,4.38-14.37,2.41-21.38s-9.4-13-16.36-10.8A24.28,24.28,0,0,0,901,131.85c-6.4,1-12.18,4.45-18.51,5.79-5.57,1.18-11.34.68-17,.81s-11.67,1-16.15,4.55-6.81,10.29-3.78,15.12c-8-.69-15.67,4.95-19.1,12.23S823.22,186.16,825,194c1.52,6.61,6.6,14.29,9.17,20.57,1,2.49,2.17,14.42,5.36,14.09,3.69-.39,4.53-10.79,4.17-13.44-3-21.67-2.74-35.09,3.25-44,6.24,5.22,12.85,10.49,20.76,12.36s17.48-.73,21.16-8a16.11,16.11,0,0,0,26.64-13.12C931.71,168.77,935.07,183.51,935.4,211.73Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-58",
    d: "M1182.16,416.33s-26.26-26.24-31.88-26.55-34.07,2.47-48.14,26.55h15.63s8.13,5.33,11.56,6.89S1190,426.63,1182.16,416.33Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M799.23,558.7h12.94l8.87,62,16.37-27.91L832.27,559H843.5l3.21,25.77L860.93,559h11.23L852.7,592.81l4.38,27.91,35.19-62h13.15l-45.88,75.93H849.38l-6-34-20.53,34H812.7Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M913.65,558.7h48.66l-2.25,10.59H923.49l-4.6,21.6h31.66l-2,9.94H916.75L911.83,624h37.54l-2.25,10.59H897.5Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M974.5,558.7h12.08L972.68,624h38.18l-2.25,10.59H958.35Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M1044.33,635.16a25.22,25.22,0,0,1-20.75-9.89,32.11,32.11,0,0,1-5.29-10.21,39.23,39.23,0,0,1-1.76-11.66,42.12,42.12,0,0,1,2-12.83,52.14,52.14,0,0,1,5.77-12.3,45.73,45.73,0,0,1,9-10.37,41.81,41.81,0,0,1,12-7.11,39,39,0,0,1,14.38-2.62q10.49,0,16.68,4.7a21.64,21.64,0,0,1,8.13,11.87l-10.16,6.1a16.12,16.12,0,0,0-3.85-7.38,13.58,13.58,0,0,0-5.83-3.53,24.25,24.25,0,0,0-6.89-1,25.6,25.6,0,0,0-12.78,3,28.32,28.32,0,0,0-9,8,35.77,35.77,0,0,0-5.4,10.8,39,39,0,0,0-1.76,11.38,29.38,29.38,0,0,0,2,11.07,18.3,18.3,0,0,0,6,8.08,15.91,15.91,0,0,0,9.78,3,22.2,22.2,0,0,0,7.38-1.34,27.5,27.5,0,0,0,7.49-4.06,25.27,25.27,0,0,0,6.31-7.11l8.77,5.67a34.51,34.51,0,0,1-9.09,9.84,40.82,40.82,0,0,1-11.5,5.88A38.59,38.59,0,0,1,1044.33,635.16Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M1112.13,635.16a25.82,25.82,0,0,1-11.76-2.57,25.19,25.19,0,0,1-8.61-7,30.61,30.61,0,0,1-5.24-10.1,39.72,39.72,0,0,1-1.76-11.82,40.3,40.3,0,0,1,2.35-13.58,49.21,49.21,0,0,1,6.52-12.4,50.41,50.41,0,0,1,9.73-10.16,46.62,46.62,0,0,1,12-6.9,36.4,36.4,0,0,1,13.32-2.51,24.93,24.93,0,0,1,11.6,2.62,25.84,25.84,0,0,1,8.61,7.11,30.57,30.57,0,0,1,5.24,10.16,40.51,40.51,0,0,1,1.71,11.76,40.92,40.92,0,0,1-2.3,13.47,47.08,47.08,0,0,1-6.47,12.36,51.46,51.46,0,0,1-9.73,10.1,47.13,47.13,0,0,1-12,6.9A36.18,36.18,0,0,1,1112.13,635.16Zm2.35-10.8a23.24,23.24,0,0,0,11.61-3,31.88,31.88,0,0,0,9.25-8,38.28,38.28,0,0,0,6.09-10.91,34.51,34.51,0,0,0,2.14-11.81,28.41,28.41,0,0,0-2-10.7,18.55,18.55,0,0,0-5.82-7.91,15,15,0,0,0-9.52-3,23.9,23.9,0,0,0-11.61,2.94,30,30,0,0,0-9.3,7.92,39.9,39.9,0,0,0-6.09,10.91,34,34,0,0,0-2.2,11.92,28.36,28.36,0,0,0,2,10.69,18.44,18.44,0,0,0,5.88,7.92A15.28,15.28,0,0,0,1114.48,624.36Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M1174.58,558.7h12.83l13.48,46.41,33.26-46.41h12.72l-16.14,75.93h-12.09L1230.3,580l-29.52,41.39h-6.63l-12-41.39-11.66,54.65h-12.08Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M1262.7,558.7h48.66l-2.25,10.59h-36.57l-4.6,21.6h31.65l-2,9.94H1265.8L1260.88,624h37.54l-2.25,10.59h-49.62Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-59",
    d: "M1706.32,543.2a197.24,197.24,0,0,0-17.39,13.5l-10.67,9.63c-3.81,3.43-7.63,7.4-11.82,11.39-16.52,16.29-35.78,36.8-57.2,60.64-13,14.71-25.07,29-36,42.85-10.77,13.93-20.76,27.1-29.09,39.58-17,24.79-28.59,46-34.36,60,5.77-13.91,13-37,26.14-64.65A402,402,0,0,1,1560.16,672a387,387,0,0,1,34.95-46.21,324.58,324.58,0,0,1,65.41-55.41c5-3.14,9.62-6.22,14.15-8.8l12.56-7.25C1695,549.92,1701.55,546.44,1706.32,543.2Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-59",
    d: "M1639.49,665.4c-5.83,3.1-13.88,9.92-23.7,19s-21.56,20-35.51,31.6l-24.4,20.39c-7.61,6.52-14.86,12.57-21.21,18.36-12.83,11.47-22.62,21.42-27.48,28.55,4.86-7.11,10.72-19.76,20.25-34.67a225.27,225.27,0,0,1,17.11-23.51,198.3,198.3,0,0,1,23.57-23.65,159.89,159.89,0,0,1,42.64-25.1C1623.42,671.11,1633.68,668.5,1639.49,665.4Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-59",
    d: "M1608.22,747.62c-4.9,1.22-12,5.31-20.63,10.85s-18.79,12.21-30.8,18.69c-7.33,4-14.42,7.76-21.13,11.32s-13,7-18.65,10.34c-11.37,6.57-20.28,12.68-24.71,17.57,4.42-4.86,9.81-14.2,18.56-24.78a140,140,0,0,1,15.66-16.24,123.18,123.18,0,0,1,21.22-14.86,99.07,99.07,0,0,1,36.77-11C1595.1,748.31,1603.34,748.84,1608.22,747.62Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-59",
    d: "M1510.57,674.56c.37,4.33,3.37,10.88,6.08,19.68a94.48,94.48,0,0,1,4.67,32.5,132.42,132.42,0,0,1-8.81,40.31c-4.12,11.06-8.37,19.4-9.61,25,1.24-5.56.86-14.93.25-26.41s-1.45-25.06-.75-39.71c.52-12,2.77-22.48,4.78-31.25S1510.94,678.9,1510.57,674.56Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-59",
    d: "M454.93,537.8a196.08,196.08,0,0,1,17.4,13.51L483,560.94c3.81,3.43,7.63,7.4,11.81,11.39,16.52,16.28,35.78,36.8,57.2,60.64,13,14.71,25.07,29,36,42.85,10.77,13.93,20.76,27.09,29.1,39.58,17,24.79,28.59,46,34.36,60-5.77-13.91-13-37-26.14-64.66a401.37,401.37,0,0,0-24.29-44.13,384.33,384.33,0,0,0-35-46.21,324,324,0,0,0-65.41-55.41c-5-3.14-9.62-6.22-14.14-8.8L474,548.89C466.25,544.53,459.71,541,454.93,537.8Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-59",
    d: "M521.77,660c5.82,3.1,13.88,9.91,23.7,19s21.55,20,35.51,31.6L605.37,731c7.62,6.51,14.86,12.57,21.22,18.36,12.82,11.46,22.62,21.42,27.47,28.55-4.85-7.12-10.72-19.76-20.24-34.67a224.22,224.22,0,0,0-17.11-23.51A198.3,198.3,0,0,0,593.14,696a160,160,0,0,0-42.64-25.1C537.84,665.71,527.58,663.11,521.77,660Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-59",
    d: "M553,742.23c4.9,1.22,12,5.31,20.64,10.85s18.79,12.21,30.8,18.69c7.32,4,14.41,7.76,21.12,11.32s13,7,18.66,10.33C655.62,800,664.53,806.11,669,811c-4.42-4.87-9.81-14.2-18.56-24.78A140,140,0,0,0,634.74,770a123,123,0,0,0-21.22-14.86,98.93,98.93,0,0,0-36.77-11C566.15,742.92,557.92,743.45,553,742.23Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-59",
    d: "M650.69,669.16c-.37,4.34-3.38,10.88-6.08,19.68a94.77,94.77,0,0,0-4.68,32.51c.73,15.47,4.67,29.29,8.82,40.31s8.37,19.4,9.61,25c-1.25-5.56-.87-14.93-.25-26.41s1.44-25.06.75-39.72c-.53-12-2.77-22.47-4.79-31.25S650.31,673.5,650.69,669.16Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-60",
    d: "M1474.91,408.2c29.3-28.77,59.54-59,73.06-97.76s4.7-88.66-30.75-109.39c-35.67-20.86-88.53,1.17-98.84,41.19-4.64,18,4.1,42.87,22.72,42.46,20.4-.45,26.37-28.24,23.81-48.48-6.6-52.1-29.51-103.79-70.67-136.41s-102-42.4-147.47-16.12c-28.5,16.48-48.21,44.42-66.66,71.69s-37.41,55.53-65.14,73.29-67,22.09-92.28,1"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-60",
    d: "M744.48,215.71c-29.44-25-75.69-27.66-107.8-6.18s-47.31,65.23-35.44,102c3.74,11.59,10.86,23.24,22.39,27.16s27-4.44,26-16.58c-1-12.51-16.17-18-28.64-19.4-43-4.78-88.28,5.08-122.5,31.47s-55.72,70.17-50.9,113.12,38.2,82.45,80.75,90"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-61",
    cx: 1063.74,
    cy: 153.01,
    r: 22.97
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-61",
    cx: 1514.08,
    cy: 87.78,
    r: 22.97
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-61",
    d: "M1097.63,310.36a13.1,13.1,0,0,0,13.09-13.1,13.11,13.11,0,0,0,13.1,13.1,13.1,13.1,0,0,0-13.1,13.09A13.09,13.09,0,0,0,1097.63,310.36Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-61",
    d: "M496.84,159.4a13.11,13.11,0,0,0,13.1-13.1A13.1,13.1,0,0,0,523,159.4a13.09,13.09,0,0,0-13.09,13.09A13.1,13.1,0,0,0,496.84,159.4Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-61",
    d: "M741.79,295.91a18.17,18.17,0,1,1-18.17-18.17A18.18,18.18,0,0,1,741.79,295.91Z"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-61",
    cx: 1611.16,
    cy: 227.14,
    r: 26.38
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-61",
    cx: 741.02,
    cy: 71.84,
    r: 30.5
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgWelcome);
export default __webpack_public_path__ + "static/media/welcome.27f04fe3c1ffe93d4c4456d55d64f7ff.svg";
export { ForwardRef as ReactComponent };